module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Lt9lqC/d2d_images/cover.jpg?1720280501750",
      "alt": "This image is the cover for the book Presa da due bagnini"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Presa da due bagnini\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Katie White è una nuotatrice professionista ventiduenne, che aspira a gareggiare alle Olimpiadi. Ogni giorno va in spiaggia per lavorare sul suo allenamento nuotando nell'oceano... e per fare alcune cose segrete e maliziose."), _c('br'), _vm._v(" Adora, tra l’altro, rifarsi gli occhi con i bagnini. Quei costumi da bagno succinti sui corpi muscolosi e abbronzati la mettono davvero di buon umore. Però i bagnini danno l’impressione di non notarla affatto, soprattutto dopo che ha rotto col fidanzato Chad, bagnino anche lui."), _c('br'), _vm._v(" Un giorno Katie viene sorpresa da un violento temporale in un luogo isolato e due bagnini vengono in suo soccorso. Uno di questi è Chad!"), _c('br'), _vm._v(" Scampata alla morte per un pelo, bloccata dalla tempesta nel capanno di pronto soccorso, Katie è terribilmente congelata. Saranno i suoi due soccorritori a riscaldarla per bene, a poco a poco..."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jasmine Black, Magali S.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jasmine Black scrive storie erotiche esclusivamente per la Spunky Girl Publishing. Le sue passioni sono l’escursionismo, il campeggio, il giardinaggio, la lettura e la scrittura. Altre storie erotiche sul sito jasmine-black.com"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Spunky Girl Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0